// @flow
import { path } from "ramda"
import type { RouterProps } from "data/router/types"

export const getRouterVariables = (props: $Supertype<RouterProps>) => {
  const id: ?number = path(["match", "params", "id"], props)
  if (id) {
    return { id }
  }
  return {}
}



// WEBPACK FOOTER //
// ./src/common/graphql/routing.js